const Text = {
  variants: {
    normal: {
      color: 'black',
      fontSize: '1em',
      lineHeight: '1.25em',
      marginBottom: '1em',
    },
    strong: {
      color: 'black',
      fontSize: '1em',
      fontWeight: 'bold',
      lineHeight: '1.25em',
      marginBottom: '1em',
    },
  },
  defaultProps: {
    variant: 'normal',
  },
};

export default Text;
